/**
 * Live-visitors resource — who is browsing with the widget loaded right now
 * (the cockpit Visitors panel). Read-only; fed by the widget's anonymous
 * presence heartbeat.
 */

import type { HttpClient } from '../httpClient';
import { endpoints } from '../endpoints';
import type { ChatSession, VisitorPresence } from '../../types';

export class VisitorsResource {
  constructor(private readonly http: HttpClient) {}

  /** Currently-active visitors for the org (newest heartbeat first, capped server-side). */
  active(): Promise<{ items: VisitorPresence[] }> {
    return this.http.get(endpoints.visitors.active());
  }

  /** Start a chat with a browsing visitor: creates a session claimed by the caller and sends
   *  their first message; the visitor's widget adopts it on its next presence beat. */
  engage(visitorId: string, body: string): Promise<ChatSession> {
    return this.http.post(endpoints.visitors.engage(visitorId), { body });
  }

  /** The visitor's recorded page-by-page journey, oldest → newest (last 50 pages, 24h). */
  path(visitorId: string): Promise<{ items: { url: string; at: string }[] }> {
    return this.http.get(endpoints.visitors.path(visitorId));
  }
}
